module.exports = __webpack_public_path__ + "static/alarm-color.81acc0b1.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/alarm-color.png
// module id = 752
// module chunks = 201563372448855 213534597649335